import React, { useState, useContext } from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import {
 BriefingContext,
} from '../../../../containers/campanhas/Briefing';
import {
    Question,
    Subtitle,
} from './style';
import color from '../../../../config/colors.json';
import Card from '../../Card';
import { FacebookLogin } from '../../../Facebook';
import { Overlayder } from '../../../Loader';
import { ReactComponent as Checked } from '../../../../img/campanhas/check.svg';

export default () => {
    const {
		campaign,
		gtm,
	} = useContext(BriefingContext);

	const {
		fbtokenSent,
		setFbtokenSent,
	} = campaign;
	const [loading, setLoading] = useState(false);
	const [refused, setRefused] = useState(false);
	return (
		<>
			{
				loading && <Overlayder text="Você será direcionado para o canal do Facebook em alguns intantes." />
			}
			<Question>
				Autorize o Cockpit no seu Facebook:
			</Question>
			<Card
				noShadow
				padding="7px 30px 2px 30px"
			>
				{
					refused && <FiAlertCircle color={color.lightRed} size="58px" style={{ margin: '25px 0 32px 0' }} />
				}
				<div className="d-flex align-items-center flex-column">
					{ refused && <Subtitle>Ops! Você não autorizou...</Subtitle> }
					{
							!fbtokenSent
							? (
								<>
									{
										refused
										? (
											<Subtitle>
												Você desativou as opções que autoriza a Webmotors a realizar sua campanha.
												<br />Por favor, clique no botão abaixo, e ative as opções para autorizar!
											</Subtitle>
										)
										: (
											<Subtitle marginTop="25px">
												Para que possamos realizar a campanha no canal escolhido,
												você precisa aceitar o convite enviado para <br />o Facebook da sua loja.
												Dessa forma, você autoriza a Webmotors a publicar os seus anúncios através
												do seu perfil.<br />Não se esqueça que somente o administrador da
												página poderá dar essa permissão.
											</Subtitle>
										)
									}
									<FacebookLogin
										setLoading={setLoading}
										setFbtokenSent={setFbtokenSent}
										setRefused={setRefused}
										buttonText="Autorizar a Webmotors"
										gtm={gtm}
									/>
								</>
							) : (
								<>
									<Checked
										width="100"
										height="auto"
										style={{ marginBottom: '10px' }}
										fill={color.lightRed}
									/>
									<Subtitle marginBottom="0">
										Você aceitou e autorizou a Webmotors a realizar a campanha!
									</Subtitle>
								</>
							)
						}
				</div>
			</Card>
		</>
	);
};
